import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=556178d7&scoped=true&"
var script = {}
import style0 from "./rule.vue?vue&type=style&index=0&id=556178d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556178d7",
  null
  
)

export default component.exports